import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";

import {
    GET_DETAIL_ACTUAL_SUPPLY_DEMAND_REPORT,
    baseUrl,
} from "../../../helpers/url_api_constant";

import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import Select from "react-select";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
//i18n
import { withTranslation } from "react-i18next";

function ActualDemandDetail(props) {
    // console.log(props);
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    let history = useHistory();
    let { date } = useParams();
    const dispatch = useDispatch();
    const permission = getPermission();
    const [pageAdd, setPageAdd] = useState(false);
    const [modelDeviceList, setModelDeviceList] = useState([]);

    const [modelListSupplyActual, setModelListSupplyActual] = useState({ COL_NAMES: [], VALUES: [] });
    const [modelListMixingGas, setModelListMixingGas] = useState({ COL_NAMES: [], VALUES: [] });

    const [listUser, setListUser] = useState([]);
    const [dropDownUser, setDropDownUser] = useState(null);

    //Sort Page//
    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total ms-2">
            Showing {from} to {to} of {size} Results
        </span>
    );
    // 
    const options = {
        paginationSize: 4,
        pageStartIndex: 1,
        // alwaysShowAllBtns: true, // Always show next and previous button
        // withFirstAndLast: false, // Hide the going to First and Last page button
        // hideSizePerPage: true, // Hide the sizePerPage dropdown always
        // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Pre page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [
            {
                text: "100",
                value: 100,
            },
            {
                text: "250",
                value: 250,
            },
            {
                text: "500",
                value: 500,
            },
            {
                text: "1000",
                value: 1000,
            },
        ],
    };

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = 'white';

        return style;
    };

    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

    //onInit//
    useEffect(function () {
        fetchData();
    }, []);
    //onInit//

    const SelectStyle = {
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
            ...provided,
            ...isFocused && ({ backgroundColor: '#2E3460' })
        }),
    }

    const gotoMainMenu = () => {
        history.push({
            pathname: "/actual-supply-demand-actual-gsm", state: {  // location state
                goBack: true,
            },
        });
    };

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.ALIAS_NAME < b.ALIAS_NAME) {
            return -1;
        }
        if (a.ALIAS_NAME > b.ALIAS_NAME) {
            return 1;
        }
        return 0;
    }

    const fetchData = async () => {
        // console.log(props.gasYear);
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_DETAIL_ACTUAL_SUPPLY_DEMAND_REPORT, { ACTUAL_YEARS: date });
            // console.log(res);
            setModelListSupplyActual(res.data.rpSupplyActualGSMList);
            setModelListMixingGas(res.data.rpMixingGasActualGSMList);

        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    function RenderHeaderSupplyActual(prop) {
        // console.log(prop);
        return (
            <th className="text-center">{prop.data}</th>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                                        <h1 className="mb-sm-0 font-size-20">
                                            Actual Supply Demand ( Actual-GSM )
                                        </h1>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="#" style={{ color: "#556ee6" }}>
                                                        Report
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to="/actual-supply-demand-actual-gsm" style={{ color: "#556ee6" }}>
                                                        Actual Supply Demand ( Actual-GSM )
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    Actual Supply Demand ( Actual-GSM ) ( Detail )
                                                </li>
                                            </ol>
                                        </div>
                                    </div>

                                    <hr />

                                    <Row>
                                        <Col
                                            sm="12"
                                            className="d-flex align-items-center justify-content-end"
                                        >
                                            <div className="d-grid gap-2 d-md-block">
                                                <Button
                                                    onClick={() => gotoMainMenu()}
                                                    // className="btn-rounded"
                                                    color="secondary"
                                                    className="mt-2 mb-2"
                                                >
                                                    <i className="fas fa-angle-double-left"></i>
                                                    &nbsp; Back
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm="3" className="d-flex align-items-center justify-content-start">
                                            <span style={{ fontSize: "2vh", color: "#FFFFFF", }}>ปริมาณการรับ-จ่ายก๊าซฯ จริง</span>
                                        </Col>
                                        <Col sm="5" className="d-flex align-items-center justify-content-left">
                                            <span style={{ fontSize: "2vh", color: "#FFFFFF", }}>เดือน {moment(date).locale('th').add(543, 'year').format("MMMM YYYY")} </span>
                                        </Col>
                                    </Row>

                                    <Row className="mt-2">
                                        <Col sm="6" className="d-flex align-items-center justify-content-start">
                                            <span style={{ fontSize: "2vh", color: "#FFFFFF", }}>หน่วย : ล้านลุกบาศก์ฟุตต่อวัน ( MMSCFD )</span>
                                        </Col>
                                    </Row>

                                    <Row className="mt-2">
                                        <Col sm="12">
                                            <div className="table-responsive" style={{ width: "100%", overflow: "auto" }}>
                                                <Table className="table table-bordered table-striped mb-0">
                                                    {/* table-dark */}
                                                    <thead style={{ fontSize: "1.5vh" }}>
                                                        <tr style={{ backgroundColor: "#556ee6", color: "#FFFFFF" }}>
                                                            {modelListSupplyActual.COL_NAMES.map((value, index) => (<RenderHeaderSupplyActual key={index} data={value} indexlist={index + 1} inDex={index} />))}
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.6vh", fontWeight: "bold" }}>
                                                        {/* backgroundColor: "#000000", */}
                                                        {modelListSupplyActual.VALUES.map((row, index) => (
                                                            <tr key={index}>
                                                                {row.map((value, indexValue) => (
                                                                    <td key={indexValue} style={{ color: index == modelListSupplyActual.VALUES.length - 1 ? "#FFF271" : "#FFFFFF", }}>
                                                                        {value == 999999 ? "Average" : indexValue != 0 ? numberFormat(value, 2) : value}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="mt-2">
                                        <Col sm="12">
                                            <div className="table-responsive" style={{ width: "100%", overflow: "auto" }}>
                                                <Table className="table table-bordered table-striped mb-0">
                                                    <thead style={{ fontSize: "1.5vh" }}>
                                                        <tr style={{ backgroundColor: "#556ee6", color: "#FFFFFF", textAlign: "center", }}>
                                                            {modelListMixingGas.COL_NAMES.map((value, indexHead) => (
                                                                <th key={indexHead}>
                                                                    {value}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.6vh", fontWeight: "bold", textAlign: "center" }}>
                                                        {/* backgroundColor: "#000000", */}
                                                        {modelListMixingGas.VALUES.map((row, index) => (
                                                            <tr key={index}>
                                                                {row.map((value, indexValue) => (
                                                                    <td key={indexValue} style={{ color: index == modelListMixingGas.VALUES.length - 1 ? "#FFF271" : "#FFFFFF", }}>
                                                                        {/* border: "solid 2px #FFFFFF" */}
                                                                        {value == 999999 ? "Average" : indexValue != 0 ? numberFormat(value, 2) : value}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    );
}

ActualDemandDetail.propTypes = {
    t: PropTypes.any,
};


export default ActualDemandDetail;
